import { create } from 'zustand';
import { AgencyAddData, AgencyListItem, AgencyUpdateData } from '@libs/models/agencies';
import { activateAgency, addAgency, fetchAgencyDetails, updateAgency } from '@libs/api/agencies';

type InitialState = {
  loading: boolean;
  currentEntityId: string;
  entity: AgencyListItem | null;
  drawerOpen: boolean;
  drawerMode: 'add' | 'edit' | 'view';

  load: (id: string) => Promise<void>;
  addAgency: (data: AgencyAddData) => Promise<void>;
  addActivateAgency: (data: AgencyAddData) => Promise<void>;
  updateAgency: (id: string, data: AgencyUpdateData) => Promise<void>;
  openDrawer: (id?: string, mode?: InitialState['drawerMode']) => void;
  closeDrawer: () => void;
};

export const useAgencyEditStore = create<InitialState>()((set) => ({
  loading: false,
  currentEntityId: '',
  entity: null,
  drawerMode: 'add',
  drawerOpen: false,

  load: async (id) => {
    set({ loading: true });
    try {
      const resp = await fetchAgencyDetails(id);
      set({
        loading: false,
        entity: resp,
      });
    } finally {
      set({ loading: false });
    }
  },
  addAgency: async (data: AgencyAddData) => {
    const id = await addAgency(data);
  },
  addActivateAgency: async (data: AgencyAddData) => {
    const id = await addAgency(data);
    await activateAgency(id);
  },
  updateAgency: async (id: string, data: AgencyUpdateData) => {
    const resp = await updateAgency(id, data);
  },
  openDrawer: (id?: string, mode?: InitialState['drawerMode']) =>
    set({ drawerOpen: true, drawerMode: mode ? mode : id ? 'edit' : 'add', currentEntityId: id ?? '' }),
  closeDrawer: () => set({ drawerOpen: false }),
}));
